
export default function ReleaseProductController(
) {
  const vm = this;

  vm.isExpanded = false;

  vm.handleExpand = _handleExpand;

  _activate();

  function _activate() {
    _initEventListeners();
  }

  /** *********************************************
   * Event Handlers
   */

  function _handleExpand() {
    vm.isExpanded = !vm.isExpanded;
  }

  /** *********************************************
   * Private Functions
   */

  function _initEventListeners() {
  }
}

ReleaseProductController.$inject = [];
